// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0c9f0dd4","239":"86eea8a3","455":"fbe18e9d"}[chunkId] + ".chunk.js";
};